module.exports = __webpack_public_path__ + "files/be5844d22731389de7ddfd05ec6cc9c8.png";